import { Injectable } from '@angular/core';
import * as Raven from 'raven-js';
import { HttpCssClient } from '../shared/http-request.interceptor';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProductPriceSettings } from '../settings/product-price.settings'
import { HttpParams } from '@angular/common/http';


@Injectable()
export class ProductPriceService{

    constructor(private http: HttpCssClient){}
    
    getPersonTypes(id, date:any):Observable<any> {
        let uri = ProductPriceSettings.PERSON_TYPES;
        uri = uri.replace(/:id/,id);
        return this.http.post(uri,{bookingDate: date})
        .pipe(map(function(response: Response){
            let body = response.body;
            return body;
        }));
    }  

    getAvailabilityProduct(id,date?) {
        let uri = ProductPriceSettings.PRODUCT_AVAILABILITY;
        uri = uri.replace(/:id/,id);
        let params = new HttpParams();
        if(date){
            params = params.set('from',`${date}`);
            //Check to register bug 20182018
            if (date != null)
            {
                try{
                    let dateCheck = date.toString();
                    let year = Number.parseInt(dateCheck.slice(0,dateCheck.indexOf('-')));                    
                    if (isNaN(year) || year > 2024)
                    {
                        throw new Error('Date too big');
                    }

                }catch (e) {
                    Raven.captureException( new Error('Date error on availabilityProduct: ' + date), {
                        level: 'warning',
                        logger: 'availability'
                    });
                }
            }

        }        
        return this.http.get(uri,params);
    }

}